import { Dialog, Heading } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const DialogHeader = styled(Dialog.Header)`
  padding: ${tokens.space.larger} ${tokens.space.large};
`;

export const DialogBody = styled(Dialog.Body)`
  min-width: 400px;
`;

export const DialogFooter = styled(Dialog.Footer)`
  padding: ${tokens.space.large} ${tokens.space.larger};
`;

export const DialogHeading = styled(Heading)`
  font-family: ${tokens.font.family.ifood.body};
  font-size: ${tokens.fontSizes.l};
  line-height: ${tokens.lineHeights.l};
`;
